import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { Observable } from 'rxjs';
import { Plant } from '../models/plant.model';

@Injectable({
  providedIn: 'root',
})
export class PlantService {
  constructor(private apiService: ApiService) {}

  public GetAllWithHierarchy(): Observable<Plant[]> {
    return this.apiService.get<Plant[]>(`/Plant/GetAllWithHierarchy`);
  }
}
